import { render, staticRenderFns } from "./DictText.vue?vue&type=template&id=2296e9f1&scoped=true"
import script from "./DictText.vue?vue&type=script&lang=js"
export * from "./DictText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296e9f1",
  null
  
)

export default component.exports